import { useMutation } from "@apollo/client";
import { css } from "@emotion/react";
import BubbleChartIcon from "@mui/icons-material/BubbleChart";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import jwt from "jsonwebtoken";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import MoonLoader from "react-spinners/MoonLoader";
import { Col, Row } from "reactstrap";
import Swal from "sweetalert2";
import { DELETE_FARMER_PROBLEMS } from "../../../../GraphQL/Mutation";
import { farmingAdd } from "../../../../redux/actions/farmerAction";
import { jwtDecode } from "jwt-decode";
import SubmitLoading from "@/utils/HelperComponent/SubmitLoading";
const FarmersProblem = ({ farmer, gen_id, creator_id }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [createUser, { data, loading, error }] = useMutation(
    DELETE_FARMER_PROBLEMS
  );
  //get token from the local storage;
  const token = localStorage?.getItem("token");
  let user;
  //verify that token ;
  // jwt.verify(token, "test", function (err, decoded) {
  //   if (err) {
  //     localStorage.removeItem("token");
  //   }
  //   user = decoded;
  // });
  try {
    const decoded = jwtDecode(token);

    // Optional: Check for token expiry
    const isExpired = decoded.exp * 1000 < Date.now();

    if (isExpired) {
      localStorage.removeItem("token");
    } else {
      user = decoded;
    }
  } catch (err) {
    // Invalid token format
    localStorage.removeItem("token");
  }
  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-success",
      cancelButton: "btn btn-danger",
    },
    buttonsStyling: false,
  });
  let [color, setColor] = useState("rgb(54, 215, 183)");

  const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;
  return (
    <div
      className="personal-info"
      style={{ border: "none", marginTop: "20px" }}
    >
      <Row>
        <Col md={10}>
          <h4 className="bold-text">
            <BubbleChartIcon fontSize="small" /> Farmers Problems
          </h4>
        </Col>
        {(user?.id === creator_id || user?.role === "admin") && (
          <Col md={2}>
            <button
              className="inbox__email-btn float-right"
              type="button"
              aria-label="edit"
              onClick={async () => {
                swalWithBootstrapButtons
                  .fire({
                    title: "Are you sure?",
                    text: "You won't be able to revert this!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete it!",
                    cancelButtonText: "No, cancel!",
                    reverseButtons: true,
                  })
                  .then(async (result) => {
                    if (result.isConfirmed) {
                      await createUser({
                        variables: { gen_id },
                        onQueryUpdated(observableQuery) {
                          // Define any custom logic for determining whether to refetch
                          if (shouldRefetchQuery(observableQuery)) {
                            return observableQuery.refetch();
                          }
                        },
                      });
                      dispatch(farmingAdd());
                      swalWithBootstrapButtons.fire(
                        "Deleted!",
                        "Your file has been deleted.",
                        "success"
                      );
                    } else if (
                      /* Read more about handling dismissals below */
                      result.dismiss === Swal.DismissReason.cancel
                    ) {
                      swalWithBootstrapButtons.fire(
                        "Cancelled",
                        "Your imaginary file is safe :)",
                        "error"
                      );
                    }
                  });
              }}
            >
              <DeleteIcon fontSize="small" />
            </button>

            <button
              className="inbox__email-btn float-right mr-1"
              type="button"
              aria-label="edit"
              onClick={() =>
                history.push({
                  pathname: "/account/major_problems",
                  state: {
                    id: gen_id ? gen_id : "",
                    farmer,
                  },
                })
              }
            >
              <EditIcon fontSize="small" />
            </button>
          </Col>
        )}
      </Row>
      {farmer?.gen_id ? (
        loading ? (
          <div>
            <SubmitLoading color="black" />
          </div>
        ) : (
          <div>
            <Row className="mt-1">
              <Col md={6}>
                <div className="profile-info">
                  <h5 className="subhead">Cold Storage:</h5>
                  <h5>
                    {farmer?.cold_storage === 1
                      ? "Yes"
                      : farmer?.cold_storage === 2
                      ? "No"
                      : ""}
                  </h5>
                </div>
              </Col>
              <Col md={6}>
                <div className="profile-info">
                  <h5 className="subhead">Comments Or Questions:</h5>
                  <h5>{farmer?.comment_question}</h5>
                </div>
              </Col>
            </Row>
            <Row className="mt-1">
              <Col md={6}>
                <div className="profile-info">
                  <p className="bold-text">
                    Problems face at the time of field operation:
                  </p>
                  <ul className="list list--icon">
                    {farmer?.problems?.map((data, index) => (
                      <li>
                        <p>
                          <span className="lnr lnr-checkmark-circle" />
                          {data?.name}
                        </p>
                      </li>
                    ))}
                  </ul>
                </div>
              </Col>
              <Col md={6}></Col>
            </Row>
          </div>
        )
      ) : (
        <div>
          <h4 className="text-center">Content is not available</h4>
        </div>
      )}
    </div>
  );
};

export default FarmersProblem;
